import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contacto2 = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    servicio: '',
    mensaje: ''
  });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const response = await axios.post(`${API}/contact/send`, formData);
      if (response.data && response.data.status === 'success') {
        toast.success('¡Mensaje enviado! Nos contactaremos contigo pronto.');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          servicio: '',
          mensaje: ''
        });
      } else {
        toast.error('No se pudo enviar el mensaje. Intenta nuevamente.');
      }
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Error al enviar el mensaje. Intenta nuevamente.';
      toast.error(detail);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-white heading-font mb-6">
            Contáctanos
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Estamos aquí para ayudarte. Comunícate con nosotros y recibe una respuesta rápida
          </p>
        </div>
      </section>

      {/* Información de Contacto y Formulario */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Información de Contacto */}
            <div>
              <h2 className="text-4xl font-bold heading-font mb-8">Información de Contacto</h2>

              <div className="space-y-6 mb-12">
                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Teléfono</h3>
                    <p className="text-gray-600">+56 9 66172797</p>
                    <p className="text-gray-600">+56 9 61684591</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Email</h3>
                    <p className="text-gray-600">contacto@sacerelectricchile.cl</p>
                    <p className="text-gray-600">ventas@sacerelectricchile.cl</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Dirección</h3>
                    <p className="text-gray-600">Cochrane 639 Oficina 54</p>
                    <p className="text-gray-600">Valparaiso, Chile</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Horario de Atención</h3>
                    <p className="text-gray-600">Lunes a Viernes: 8:00 - 18:00</p>
                    <p className="text-gray-600">Sábado: 9:00 - 14:00</p>
                    <p className="text-yellow-600 font-semibold mt-2">Emergencias 24/7</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Formulario */}
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <h2 className="text-3xl font-bold heading-font mb-6">Enviar Mensaje</h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact2-form">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    data-testid="contact2-input-nombre"
                    className="form-input w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    data-testid="contact2-input-email"
                    className="form-input w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    data-testid="contact2-input-telefono"
                    className="form-input w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="+56 9 1234 5678"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Servicio de Interés *
                  </label>
                  <select
                    name="servicio"
                    value={formData.servicio}
                    onChange={handleChange}
                    required
                    data-testid="contact2-input-servicio"
                    className="form-input w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 transition-colors"
                  >
                    <option value="">Seleccionar servicio</option>
                    <option value="electrica">Servicios Eléctricos</option>
                    <option value="construccion">Construcción</option>
                    <option value="mantencion">Mantención</option>
                    <option value="proyectos">Proyectos Especiales</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Mensaje *
                  </label>
                  <textarea
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    rows={4}
                    data-testid="contact2-input-mensaje"
                    className="form-input w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 transition-colors resize-none"
                    placeholder="Cuéntanos sobre tu proyecto o consulta..."
                  />
                </div>

                <button
                  type="submit"
                  disabled={sending}
                  data-testid="contact2-submit-btn"
                  className="w-full btn-primary flex items-center justify-center space-x-2 disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  <span>{sending ? 'Enviando...' : 'Enviar Mensaje'}</span>
                  <Send className="w-5 h-5" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Emergencias */}
      <section className="py-20 bg-gradient-to-br from-red-600 to-red-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <Phone className="w-16 h-16 text-yellow-400 mx-auto mb-6 animate-pulse" />
          <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-6">
            ¿Emergencia Eléctrica?
          </h2>
          <p className="text-xl text-gray-100 mb-8 max-w-2xl mx-auto">
            Atención 24/7 para emergencias. Llámanos ahora
          </p>
          <a href="tel:+56912345678" className="inline-block">
            <button className="bg-yellow-400 text-red-700 font-bold text-2xl px-12 py-5 rounded-xl hover:bg-yellow-300 transition-all duration-300 shadow-2xl">
              +56 9 1234 5678
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contacto2;
